module.exports = __webpack_public_path__ + "static/media/belpasso_logo.eb69297d.png";